import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { PricePipe } from '@lx/shared/ui/pipes';
import { TableModule } from 'primeng/table';
import { CompanyEnum } from '../../../models/company.model';
import { PriceListAccommodation } from '../../../models/pricelist-accommodation.model';
import { AccommodationTableLabels, AlpAccommodationDataTable, AlpAccommodationOptionsDataTable } from '../../../models/types';
import { PriceListAccommodationBandsService } from '../../../services/pricelist-accommodation-bands.service';
import { getBandFromMinMax } from '../../../utils/table-utils';

@Component({
  standalone: true,
  imports: [CommonModule, PricePipe, TableModule],
  selector: 'lx-price-lists-portal-alp-accommodation-table',
  templateUrl: './alp-accommodation-table.component.html',
  styleUrls: ['./alp-accommodation-table.component.scss'],
})
export class AlpAccommodationTableComponent implements OnInit {
  @Input() accommodations: PriceListAccommodation | undefined;
  @Input() notationMarks: Record<string, string> | undefined;

  dataSource: AlpAccommodationDataTable[] = [];
  columnLabels: AccommodationTableLabels | undefined;

  companyEnum = CompanyEnum;

  private readonly priceListAccommodationBandsService = inject(PriceListAccommodationBandsService);

  ngOnInit(): void {
    this.dataSource = this.accommodations?.products.reduce<AlpAccommodationDataTable[]>((accommodations, { name, options: productOptions, noteCode }) => {
      const options = productOptions.reduce<AlpAccommodationOptionsDataTable[]>((opts, { roomType: type, meals, bathroom, minAge, prices, noteCode }) => {
        const pricesByBand = prices.reduce<Record<string, number>>((prices, { price, duration: { min, max } }) => {
          const band = getBandFromMinMax(min, max);
          const newPrices = { ...prices };
          newPrices[band] = price;
          return newPrices;
        }, {});
        return [
          ...opts,
          {
            type,
            meals,
            bathroom,
            minAge,
            prices: pricesByBand,
            noteCode,
          },
        ];
      }, []);
      return [
        ...accommodations,
        {
          name,
          options,
          noteCode,
        },
      ];
    }, []);

    this.columnLabels = this.priceListAccommodationBandsService.getColumnLabels(this.accommodations);
  }
}
